<template>
	<v-app :dark="darkMode">
		<v-btn fab fixed bottom right small color="primary" @click="postingcreate">
		    <v-icon>fas fa-plus</v-icon>
		</v-btn>
		<div id="App" class="application" data-app="true">
			<div class="application--wrap">
			    <keep-alive>
			    	<router-view></router-view>
				</keep-alive>
			</div>
		</div>
	</v-app>
</template>
<style scoped>

</style>
<script>
	import Vue from 'vue'
	import config from './config.js'
	import { mapGetters } from 'vuex'
	import AppLogo from './components/Logo.vue'
	import AppHeader from './components/Header.vue'
	import AppLeft from './components/Left.vue'
	import AppRight from './components/Right.vue'
	import AppTags from './components/Tags.vue'
	import AppTerms from './components/Terms.vue'
	import AppMenu from './components/Menu.vue'
	import AppUserSearch from './components/UserSearch.vue'
	import AppLinkInvalid from './components/LinkInvalid.vue'
	import AppVerificationSlider from './components/VerificationSlider.vue'
	import AppVerificationCode from './components/VerificationCode.vue'
	Vue.component('AppLogo', AppLogo);
	Vue.component('AppHeader',AppHeader);		//注册头部组件
	Vue.component('AppLeft',AppLeft);			//注册左侧组件
	Vue.component('AppRight',AppRight);			//注册右侧组件
	Vue.component('AppTags',AppTags);			//注册标签组件
	Vue.component('AppTerms',AppTerms);			//注册条款组件
	Vue.component('AppMenu',AppMenu);			//注册菜单组件
	Vue.component('AppUserSearch',AppUserSearch);					//注册用户搜索组件
	Vue.component('AppLinkInvalid',AppLinkInvalid);					//注册链接无效组件
	Vue.component('AppVerificationSlider',AppVerificationSlider);	//注册验证滑块组件
	Vue.component('AppVerificationCode',AppVerificationCode);		//注册随机验证码组件
    export default {
        name: 'app',
        data(){
		    return{

		    }
	  	},
	  	computed: {
			...mapGetters(["user","darkMode"])
		},
		mounted(){
			this.getUserDetail();
			this.refreshLogin();
			this.addVisitVolume();
			this.getNewNotificationNum();
			this.getMarkets();
			this.isOldPassword();
			if(this.$store.state.user.token){
				this.getIp();
			}
		},
	   	methods:{
	   		//发帖
			postingcreate(){
			    if(localStorage.getItem('token')) {
			        this.$router.push({name:'createPost'});
			    } else {
			        this.$store.state.loginModal = true;
			    }
			},
			refreshLogin(){
				if(this.$store.state.user.token) {
					this.$http.get(config.baseUrl + "userDetail/refreshLogin").then((response) => {
						let data = response.data;
						if (data.resCode == 0) {
							let token = data.result;
							this.$store.state.user.token = token;
							localStorage.setItem("token", token);
						}
					});
			    }
			},
			getUserDetail(){
				if (this.$store.state.user.token) {
					this.$http.get(config.baseUrl + "userDetail/getMe").then((successData) => {
				        let data = successData.data;
				        if (data.resCode == 0) {
				            let user = data.result;
				            this.getRole(user.roleId);
				            this.$store.dispatch("userHandler", user);
				            this.$store.dispatch("localeHandler", user.i18nCode);
	                    	this.$store.dispatch("darkModeHandler", user.darkMode);
	    					this.$store.dispatch("changeColorStyleHandler", user.colorStyle);
	    					/************************************************/
	    					this.$vuetify.theme = this.$store.getters.selectedTheme.theme;
				        }
				    });
				} else {
					let darkMode = localStorage.getItem("SIP-darkMode");
					if (darkMode == true) {
						this.$store.dispatch("darkModeHandler", true);
					} else if (darkMode == false) {
						this.$store.dispatch("darkModeHandler", false);
					}
					let colorStyle = localStorage.getItem("SIP-colorStyle");
					if (colorStyle) {
						this.$store.dispatch("changeColorStyleHandler", colorStyle);
	    				this.$vuetify.theme = this.$store.getters.selectedTheme.theme; 
					}
				}
			},
			getRole(roleId){
				this.$http.get(config.baseUrl + "role/open/getRole?roleId=" + roleId).then((successData) => {
			        let data = successData.data;
			        if (data.resCode == 0) {
			            this.$store.dispatch("roleHandler", data.result);
			        }
			    });
			},
			addVisitVolume(){
				this.$http.get(config.baseUrl + "visit/open/visit");
			},
			// 查询消息通知数量
		    getNewNotificationNum(){
		    	if (this.$store.state.user.token) {
		        	this.$http.get(config.baseUrl + 'notification/query/getNewNotificationNum').then(response => {
		        	let data = response.data;
		        	if (data.resCode == 0) {
		        		this.$store.dispatch('notificationNumHandler', data.result);
		        	} 
		        });
		      }
		    },
		    // 获得市场分类的集合
		    getMarkets() {
		    	this.$http.get(config.baseUrl + "market/open/getMarkets").then(response => {
		        	let data = response.data;
		        	if (data.resCode == 0) {
		            	this.$store.dispatch("marketsListHandler", data.result);
		        	}
		        });
			},
			// 获取当前ip
			getIp(){
                var url = "https://pv.sohu.com/cityjson?ie=utf-8";
                this.$http.get(url).then(response=>{
                    var data = response.data;
                    data = JSON.parse(data.substr(18,data.legth).replace(";",""));
                    var ip = data.cip;
                    this.getAdd(ip);
                })
			   },
			   // 获取国家码
               getAdd(ip){
                // var api = "http://ip.taobao.com/service/getIpInfo.php?ip="+ip;
                // var url = "http://ip-api.com/json/"+ip
                // this.$http.get(url).then(response=>{
	            //     var data = response.data;
				// 	var countryCode = data.countryCode;
				// 	if(this.$store.state.user.token) {
				// 		this.updateUserTimeZones(countryCode,ip)
				// 	}
	            //     console.log(countryCode)
				// })
				var api = config.baseUrl + "visit/open/getCountryCode?ip="+ip;
				this.$http.get(api).then(response =>{
					var data = response.data
					if( 0 == data.resCode){
						var countryCode = data.resMsg
						this.updateUserTimeZones(countryCode,ip)
					}
				})
			   },
			   // 更新用户时区
			updateUserTimeZones(countryCode,ip){
				var param = {countryCode:countryCode,ip:ip}
				var api = config.baseUrl + 'userDetail/update/updateUserTimeZone'
				this.$http.post(api,param).then(response=>{
					var data = response.data;
					if(data.resCode == 0){
						this.$router.go();
					}
				})
			},
		    // 是否为旧密码
		    isOldPassword(){
		    	if(this.$store.state.user.token) {
		        	let api = config.baseUrl + 'user/isOldPassword';
		        	this.$http.get(api).then(response=> {
		          		let data = response.data;
		        		if (data.resCode == 0) {
				            if (data.result) {
				              this.logout();
				            }
		        		}
		    		})
		    	}
		    },
		    // 退出
		    logout(){
		    	localStorage.removeItem("SIP-user");
		    	localStorage.removeItem("SIP-role");
		    	localStorage.removeItem("userName");
		    	localStorage.removeItem("id");
		    	localStorage.removeItem("token");
		    	localStorage.removeItem("image");
		    	localStorage.removeItem("invitationCode");
		    	this.$store.state.user.id = null;
		    	this.$store.state.user.name = null;
		    	this.$store.state.user.token = null;
		    	this.$store.state.user.image = null;
		    	this.$router.push({name:'home'});
		    	this.$router.go();
		    },
		}
}
</script>



// WEBPACK FOOTER //
// App.vue?34fabb38